import { useQuestionizerStore } from "../types/state.ts";
import InputAntragsteller from "./input-antragsteller.tsx";
import InputBaujahr from "./input-baujahr.tsx";
import InputEvu from "./input-evu.tsx";
import InputGebaeudeTyp from "./input-gebaeude-typ.tsx";
import InputGewerk from "./input-gewerk.tsx";
import InputGrundversorger from "./input-grundversorger.tsx";
import InputPlz from "./input-plz.tsx";

import InputGemeinnuetzig from "./input-gemeinnuetzig.tsx";
import InputWohngebaeude from "./input-wohngebaude.tsx";
import InputGewerbeGebaeude from "./input-gewerbegebaeude.tsx";
import InputAntragstellerSelect from "./input-antragsteller-select.tsx";
import InputGebaeudeTyp3 from "./input-gebaeude-typ-3.tsx";
import InputAltbauNeubau from "./input-altbau-neubau.tsx";
import InputForm from "./input-form.tsx";
import InputResult from "./questionizer-result.tsx";
import InputGroupToggle from "./input-group-toggle.tsx";
import { Button } from "./button.tsx";
import { useState } from "react";

export default function QuestionizerForm(){
    const [last_key, set_last_key] = useState(false);
    const step = useQuestionizerStore((state) => state.step);  
    const config = useQuestionizerStore((state) => state.config);
    //const active_groups = useQuestionizerStore((state) => state.active_groups);
    const active_group = useQuestionizerStore((state) => state.active_group);
    const toggleGroup = useQuestionizerStore((state) => state.toggleGroup);
    //const active_items_per_group = useQuestionizerStore((state) => state.active_items_per_group);

    if (!config){
      return <div>Ein Fehler ist aufgetreten: Keine Konfiguration gefunden.</div>
    }
    
    //const baseurl = (config?.baseurl! + (config?.country ? config?.country! + "/" : "") + (config?.app ? config?.app + "/" : "")) || "";
    const baseurl = config?.baseurl! || "";

    const currentStep = config!.layout[step];

    const inputs = currentStep.sections.map((section,section_index) => {

      // let cols = "";
      // switch (section.inputs.length){
      //   case 1: cols += "grid-cols-1 sm:grid-cols-1"; break;
      //   case 2: cols += "grid-cols-2 sm:grid-cols-2"; break;
      //   case 3: cols += "grid-cols-2 sm:grid-cols-3"; break;
      //   default: cols += "grid-cols-2 sm:grid-cols-3";
      // }

      //let layout = 'w-fot grid ' + cols;
      let layout = 'section__inputs--grid'
      if (section.type === "column") {
        layout = "w-full flex flex-col";
      }else if (section.type === "row") {
        layout = "w-full flex flex-row";
      }

      //let section_active = section.group !== undefined ? active_groups[section.group] == true : true;
      const is_group_section = section.groups !== undefined;
      const section_active = is_group_section ? section.groups?.includes(active_group ?? 99) : true;
      // let activeItems = 0;
      // if (is_group_section){
      //   activeItems = active_items_per_group[section.group];
      // }

      const  section_id = (section.id == undefined ? section_index : section.id);


      return (<div role="group" 
        inert={section.inputs.length == 0 || (is_group_section && !section_active)} 
        aria-expanded={!is_group_section || section_active}
        tabIndex={is_group_section ? 0 : -1}
        className={
          (is_group_section ? "group group-"+section.groups![0] : "") + 
          (section_index == 0 ? "top_section" : "") + 
          (" section section-" + section_id) + 
          (section_active ? "" : " section--hidden") + 
          (is_group_section ? " section--group" : "")
        } 
        key={section_id}
      >
        <div role="heading" aria-level="2" className="section__header">
          {section.title && <h2 className="section__title">{section.title}</h2>}
          {section.info_top && <p className="section__info-top">{section.info_top}</p>}
        </div>
        <div className={"section__inputs " + layout}>
          {section.type === "grid" && section.inputs.length == 2 ? <div className={"tw-sm-hidden md:block sm:col-span-2 hidden lg:block"}></div> : <></>}
          {section.inputs.map( (input, index, array) => {
            let is_last = index == array.length - 1;
            const onBlur = (is_group_section && is_last) ? ()=>{
              // console.log("exit last");
              // document.querySelector(".input-"+section_id)?.focus();
            } : ()=>{};

          switch (input.type){
            case 'plz':
              return <InputPlz label={input.label} id={input.id} key={input.id} onBlur={onBlur}></InputPlz>
            case 'grouptoggle':
             return <InputGroupToggle label={input.label} info_title={input.info_title} info_text={input.info_text} icon={baseurl + input.icon} icon_active={baseurl + input.icon_active} id={input.id} deactivate_ids={input.deactivate_ids} key={input.id} onBlur={()=>{
                onBlur();
                if(input.id != active_group || last_key){return;}
                //document.querySelector(".input-"+input.id)?.focus();
                setTimeout(()=>{
                  document.querySelector(".group-"+input.id+" .toggle")?.focus();
                }, 100);
             }}/>
            case 'gewerk':
              return <InputGewerk label={input.label} info_title={input.info_title} info_text={input.info_text} icon={baseurl + input.icon} icon_active={baseurl + input.icon_active} id={input.id} deactivate_ids={input.deactivate_ids} key={input.id} onBlur={onBlur}></InputGewerk>
            case 'altbau_neubau':
                return <InputAltbauNeubau 
				  label_altbau={input.label_altbau}
					label_neubau={input.label_neubau}
					icon_altbau={baseurl + input.icon_altbau} 
					icon_altbau_active={baseurl + input.icon_altbau_active} 
					icon_neubau={baseurl + input.icon_neubau} 
					icon_neubau_active={baseurl + input.icon_neubau_active} 
					id={input.id} 
					key={input.id} onBlur={onBlur}></InputAltbauNeubau>
            case 'gebaeude_typ':
              return <InputGebaeudeTyp
                label_einfamilienhaus={input.label_einfamilienhaus}
                label_mehrfamilienhaus={input.label_mehrfamilienhaus}			  
				icon_einfamilienhaus={baseurl + input.icon_einfamilienhaus} 
				icon_einfamilienhaus_active={baseurl + input.icon_einfamilienhaus_active} 
				icon_mehrfamilienhaus={baseurl + input.icon_mehrfamilienhaus} 
				icon_mehrfamilienhaus_active={baseurl + input.icon_mehrfamilienhaus_active} 
				id={input.id} key={input.id} onBlur={onBlur}></InputGebaeudeTyp>
            case 'gebaeude_typ_3':
              return <InputGebaeudeTyp3 
                label_einfamilienhaus={input.label_einfamilienhaus}
                label_mehrfamilienhaus={input.label_mehrfamilienhaus}
                label_nichtwohngebaeude={input.label_nichtwohngebaeude}
                icon_einfamilienhaus={baseurl + input.icon_einfamilienhaus} 
                icon_einfamilienhaus_active={baseurl + input.icon_einfamilienhaus_active} 
                icon_mehrfamilienhaus={baseurl + input.icon_mehrfamilienhaus} 
                icon_mehrfamilienhaus_active={baseurl + input.icon_mehrfamilienhaus_active} 
                icon_nichtwohngebaeude={baseurl + input.icon_nichtwohngebaeude} 
                icon_nichtwohngebaeude_active={baseurl + input.icon_nichtwohngebaeude_active} 
                id={input.id}
                key={input.id} onBlur={onBlur}></InputGebaeudeTyp3>
            case 'baujahr':
              return <InputBaujahr label={input.label} id={input.id} key={input.id} onBlur={onBlur}></InputBaujahr>
            case 'grundversorger':
              return <InputGrundversorger label={input.label} id={input.id} key={input.id} onBlur={onBlur}></InputGrundversorger>
            case 'antragsteller':
              return <InputAntragsteller label={input.label} icon={baseurl + input.icon} icon_active={baseurl + input.icon_active} antragsteller_type={input.code} id={input.id} key={input.id} onBlur={onBlur}></InputAntragsteller>
            case 'antragsteller-select':
                return <InputAntragstellerSelect label={input.label} id={input.id} key={input.id} onBlur={onBlur}></InputAntragstellerSelect>
            case 'evu':
              return <InputEvu label={input.label} id={input.id} key={input.id} onBlur={onBlur}></InputEvu>
            case 'gemeinnuetzig':
              return <InputGemeinnuetzig label={input.label} icon={baseurl + input.icon} icon_active={baseurl + input.icon_active} id={input.id} key={input.id}  onBlur={onBlur}/>
            case 'wohngebaeude':
              return <InputWohngebaeude label={input.label} icon={baseurl + input.icon} icon_active={baseurl + input.icon_active} id={input.id} key={input.id} onBlur={onBlur}/>
            case 'form':
              return <InputForm id={input.id}  firstname={input.firstname} lastname={input.lastname} email={input.email} tel={input.tel} key={input.id} dataprotection_link={input.dataprotection_link}  dataprotection_link_text={input.dataprotection_link_text} dataprotection_a={input.dataprotection_a} dataprotection_b={input.dataprotection_b} onBlur={onBlur}/> 
            case 'result':
              return <InputResult id={input.id} key={input.id} onBlur={onBlur}/> 
            case 'gewerbegebaeude':
              return <InputGewerbeGebaeude label={input.label} icon={baseurl + input.icon} icon_active={baseurl + input.icon_active} id={input.id} key={input.id} onBlur={onBlur}/>
          }
        })}</div>
		    {is_group_section && <Button 
              label="Weitere Maßnahmen"
              className="step_buttons__next mr-auto ml-auto mt-4"
              icon_right_class="icon-inline--right icon-right--white pl-4"
              onClick={()=>{
                if(is_group_section){
                  toggleGroup(section.groups![0]!, false);
                  //console.log("focus -> .input-"+section_id);
                  document.querySelector(".input-"+section.groups![0])?.focus();
                  document.getElementById("febis-questionizer")?.scrollIntoView({ block: 'start',  behavior: 'smooth' })
                }
              }}
            />
        }
        {section.info_bottom && <p role="note" className="section__info-bottom">{section.info_bottom}</p>}
      </div>);
    });
    
    return (<>
			<h1 className="form__title">{currentStep.title}</h1>
			<div className={`form form-${step ?? 0}`}
            onKeyUp={ (event) => {
            set_last_key(event.code == "Tab" && event.shiftKey);
            }}
        >      
				{inputs}
			</div>
		  </>);   
  }     